import * as React from "react";
import { useState, useEffect } from "react";
import PublicLayout from "../components/PublicLayout";
import PublicHeader from "../components/PublicHeader";
import calendarIcon from "../assets/icons/calendar.svg";
import { Box, Typography } from '@mui/material';

const TermsAndConditions: React.FC = () => {
  return (
    <>
      <PublicLayout>
        <Box 
          display="flex" 
          flexDirection="column" 
          alignItems="flex-start"
          width="98%"
        >
          <PublicHeader />

          <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="left" 
            p="20px"
            height="calc(100% - 80px)"
          >
            <Box 
              display="flex" 
              flexDirection="column" 
              alignItems="left" 
              p="20px"
              sx={{
                overflow: "auto", 
              }}
            >
              <Box 
                display="flex" 
                flexDirection="row" 
                alignItems="center" 
              >
                <img
                    src={calendarIcon}
                    style={{
                        display: "flex",
                        height: 32,
                        width: 32,
                        marginTop: "5px"
                    }}
                />
                <Typography
                  sx={{
                    width: "100%",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 400,
                    fontSize: 20,
                    lineHeight: "100%",
                    letterSpacing: "-0.04em",
                    color: "#0C0D0E",
                  }}
                >
                  Ultimo aggiornamento: 15.10.2025
                </Typography>
              </Box>


              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 700,
                  fontSize: 48,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                Termini e Condizioni d’Uso dell’Applicazione Mobile “Nimbleness” 
              </Typography>

              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                La presente informativa disciplina le condizioni di utilizzo dell’applicazione mobile denominata “Nimbleness” (di seguito anche “App”), resa disponibile per dispositivi mobili. 
                L’app è di proprietà ed è gestita da VIRTU ALE SRLS (di seguito anche “Titolare”), con sede legale in Spoleto, Via Pontano n. 63, e-mail: virtuale@nimbleness.it 
              </Typography>


              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                1. Oggetto e finalità dell’applicazione 
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’app Nimbleness è concepita per consentire agli utenti di svolgere esercizi fisici e sessioni di allenamento con il supporto di un sistema digitale che analizza la postura e i movimenti del corpo, restituendo un punteggio di valutazione qualitativa dell’esercizio svolto.<br/>
                L’applicazione è destinata esclusivamente ad un uso personale e privato. L’utente si impegna a non utilizzare l’app per scopi professionali, commerciali o di lucro, né a fornire a terzi l’accesso alla propria utenza.
              </Typography>


              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                2.  Accettazione delle condizioni
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’utilizzo dell’app comporta l’accettazione piena e incondizionata delle presenti Condizioni Generali di Uso e Licenza. Registrandosi e creando un account personale, l’utente dichiara di aver letto, compreso e accettato il contenuto integrale del presente documento e della Privacy Policy allegata, che ne costituisce parte integrante.<br/>
                Qualora l’utente non intenda accettare anche solo una delle disposizioni qui contenute, è tenuto ad astenersi dall’utilizzo dell’applicazione e a disinstallarla immediatamente dal proprio dispositivo.
              </Typography>


              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                3. Registrazione e credenziali di accesso<br/>
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Per utilizzare l’app è necessario creare un account personale mediante l’inserimento di nome, indirizzo e-mail e password. L’utente si impegna a fornire dati corretti, aggiornati e veritieri e a non utilizzare indirizzi di terzi senza autorizzazione.<br/>
                Le credenziali di accesso sono strettamente personali e non possono essere condivise con altri soggetti. L’utente è responsabile della loro custodia e del corretto utilizzo dell’account, esonerando il Titolare da qualsiasi responsabilità per eventuali usi impropri o non autorizzati.<br/>
                Il Titolare si riserva la facoltà di sospendere o disattivare l’account dell’utente in caso di utilizzo illecito, improprio o in violazione delle presenti condizioni.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                4. Licenza d’uso
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’installazione e l’utilizzo dell’app Nimbleness avvengono in virtù di una licenza d’uso personale, limitata, non esclusiva, non trasferibile e revocabile, concessa all’utente unicamente per scopi privati e non commerciali.<br/>
                L’utente non acquisisce alcun diritto di proprietà sull’app, sul codice sorgente, sul design, sui marchi o sui contenuti in essa presenti. È fatto espresso divieto di copiare, modificare, decompilare, disassemblare, tradurre, vendere, distribuire, sublicenziare o creare opere derivate basate sull’applicazione o su parte di essa, salvo previa autorizzazione scritta del Titolare.<br/>
                L’app viene fornita “così com’è” (“as is”), senza garanzie di alcun tipo circa la disponibilità continua, la compatibilità o l’assenza di errori.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                5. Uso corretto e responsabilità dell’utente
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’utente si impegna ad utilizzare l’app esclusivamente nel rispetto della legge e delle presenti condizioni, evitando comportamenti che possano compromettere la sicurezza, la funzionalità o l’integrità del sistema.<br />
                In particolare, l’utente si impegna a:<br />
                <ul>
                <li>non tentare di accedere a parti del sistema non autorizzate o a funzioni riservate;</li>
                <li>non interferire con le comunicazioni tra app e server;</li>
                <li>non utilizzare l’app per scopi medici o terapeutici, né per sostituire la valutazione di un professionista sanitario;</li>
                <li>non caricare o diffondere contenuti offensivi, illeciti o contrari al buon costume.</li>
                </ul>
                Il Titolare non potrà essere ritenuto responsabile per eventuali danni diretti o indiretti derivanti da un uso improprio dell’app, da errori di valutazione automatica o da disfunzioni tecniche temporanee.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                6. Funzionamento tecnico e requisiti
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’app richiede l’accesso alla fotocamera del dispositivo per poter analizzare i movimenti dell’utente durante le sessioni di allenamento. Tale accesso avviene solo previo consenso esplicito dell’utente e resta limitato alla durata della sessione.<br/>
                I dati video e i punti di riferimento corporei elaborati dal sistema non vengono archiviati permanentemente sui server del Titolare, ma utilizzati esclusivamente per restituire un punteggio istantaneo.<br/>
                Per un corretto funzionamento dell’app è necessario disporre di una connessione Internet attiva.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                7. Proprietà intellettuale
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Tutti i diritti di proprietà intellettuale relativi all’applicazione Nimbleness, al relativo logo, ai contenuti testuali, grafici e multimediali, nonché al codice sorgente e alle banche dati connesse, sono e restano di esclusiva titolarità di VIRTU ALE SRLS (il Titolare).<br/>
                Qualsiasi utilizzo non autorizzato dei contenuti o della tecnologia dell’app costituirà violazione dei diritti di proprietà intellettuale e potrà essere perseguito ai sensi di legge.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                8. Manutenzione, aggiornamenti e interruzioni del servizio
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Il Titolare potrà, in qualunque momento e senza preavviso, apportare modifiche tecniche, aggiornamenti o miglioramenti all’applicazione, nonché interrompere temporaneamente o definitivamente il servizio per esigenze di manutenzione o per cause di forza maggiore.<br />
                Eventuali aggiornamenti potranno essere installati automaticamente sul dispositivo dell’utente, ove necessario per garantire la sicurezza e la compatibilità del sistema.<br />
                Il Titolare non garantisce la disponibilità continua dell’app e non risponde per eventuali interruzioni, perdita di dati o malfunzionamenti derivanti da fattori esterni (rete, dispositivi, sistemi operativi).<br />
                Qualsiasi utilizzo non autorizzato dei contenuti o della tecnologia dell’app costituirà violazione dei diritti di proprietà intellettuale e potrà essere perseguito ai sensi di legge.<br />
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                9. Limitazioni di responsabilità
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’app Nimbleness non è un dispositivo medico né sostituisce la consulenza di professionisti della salute o del fitness.<br/>
                I risultati, i punteggi o le valutazioni forniti dall’app hanno valore meramente indicativo e non costituiscono diagnosi, prescrizioni o indicazioni terapeutiche.<br/>
                Il Titolare non assume responsabilità per:
                <ul>
                <li>danni derivanti da un utilizzo non corretto dell’app;</li>
                <li>malfunzionamenti imputabili a software di terze parti, reti o dispositivi dell’utente;</li>
                <li>eventuali perdite di dati dovute a guasti o interruzioni del servizio;</li>
                </ul>
                violazioni commesse dall’utente in relazione alle presenti condizioni.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                10. Privacy e trattamento dei dati personali
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’utilizzo dell’app comporta il trattamento di alcuni dati personali degli utenti, disciplinato nella Privacy Policy disponibile nella schermata di login e consultabile in ogni momento all’interno dell’app.<br/>
                L’utente è invitato a leggere attentamente la Privacy Policy prima di utilizzare l’applicazione.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                11. Durata e cessazione
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                La licenza d’uso dell’app Nimbleness è concessa per la durata dell’utilizzo dell’applicazione. L’utente può cessare il rapporto in qualsiasi momento disinstallando l’app dal proprio dispositivo.<br/>
                Il Titolare potrà sospendere o revocare l’accesso all’app in caso di violazione delle presenti condizioni, di uso illecito o per motivi tecnici o di sicurezza.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                12. Modifiche alle condizioni
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Il Titolare si riserva il diritto di modificare in qualsiasi momento le presenti condizioni d’uso. Le modifiche entreranno in vigore dal momento della pubblicazione o dalla comunicazione tramite e-mail all’indirizzo fornito in fase di registrazione.<br/>
                L’utilizzo continuato dell’app successivamente alla comunicazione delle modifiche equivale ad accettazione delle nuove condizioni.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                13. Legge applicabile e foro competente
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Le presenti condizioni sono disciplinate dalla legge italiana.<br/>
                Per ogni controversia relativa all’interpretazione, esecuzione o validità delle presenti condizioni, sarà competente in via esclusiva il Foro di Spoleto.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                14. Contatti
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Per qualsiasi richiesta, segnalazione o reclamo relativo all’app Nimbleness o alle presenti condizioni, l’utente può scrivere all’indirizzo e-mail: pr@nimbleness.it all’attenzione del titolare dell’app e dei diritti connessi: VIRTU ALE SRLS (il Titolare).
              </Typography>
            </Box>
            
          </Box>
        </Box>
      </PublicLayout>

    </>
  );
};

export default TermsAndConditions;

